import Main from './Main.vue'
import Documentos from './components/Documentos'
import Documento from './components/Documento'

export default [{
  path: 'documentos',
  name: 'documentos',
  component: Main,
  children: [
    {path: '/', component: Documentos, name: 'documentos'},
    {path: 'registro', component: Documento, name: 'documento.novo'},
    {path: ':id/edit', component: Documento, name: 'documento.editar'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/documentos/routes.js